<script>
import { enemyComponents } from '@/config'

import EnemyAfv from './EnemyAfv'
import EnemyRifleman from './EnemyRifleman'

export default {

  components: {
    EnemyAfv,
    EnemyRifleman
  },

  props: {
    type: {
      type: String,
      required: true
    }
  },

  computed: {

    component () {
      return enemyComponents[this.type]
    }

  }

}
</script>

<template>
  <a-entity
    geometry="primitive: box; width: 1; height: 2; depth: 1;"
    material="visible: false"
  >
    <component :is="component" />
  </a-entity>
</template>
